import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {SkeletonComponent} from "@syncfusion/ej2-vue-notifications";

export default /*@__PURE__*/_defineComponent({
  __name: 'SogSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SkeletonComponent), { height: "48px" }))
}
}

})